/*
 * ******************************************************************
 * Copyright (c) 2022-2024 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { APP_ROUTES_UTIL } from "@app/app-routing.util";
import { Router } from "@angular/router";
import { ServiceTypeEnum } from "@api/generated/vcdr";

export enum SetupRegionFlow {
    DEPLOY = "DEPLOY",
    IMPORT = "IMPORT"
}

export abstract class NavigateService {

    protected constructor(public router: Router) {
    }

    abstract navigateToSubscriptions(): void;

    abstract navigateToRegions(): void;

    abstract navigateToTasks(): void;

    abstract navigateToTask(taskId: string, task?: any): void;

    abstract runRegionsSetup(mode?: SetupRegionFlow, serviceType?: ServiceTypeEnum): void;

    abstract navigateToSuccess(): void;

    abstract getRootPath(): string;

    navigateToRoute(route: string[] | string, reloadState?: boolean): void {
        const navigationRoute = Array.isArray(route) ? route : [route];

        if (reloadState) {
            this.router.navigate(navigationRoute, { queryParams: { "reload-state": reloadState } });
        } else {
            this.router.navigate(navigationRoute);
        }
    }

    setRootLink(): void {
        // CSP header link defaults to app root, so we need to change it to the specific console root.
        const rootPath = APP_ROUTES_UTIL.absolutePath(this.getRootPath());
        const cspHeaderLinkElements = document.getElementsByClassName("title-link");
        const cspHeaderLink = cspHeaderLinkElements?.length ? cspHeaderLinkElements[0] : null;
        cspHeaderLink?.setAttribute("href", rootPath);
    }
}
